import React, { useState, useEffect, Fragment, memo } from 'react';
import * as _ from 'lodash';
import Helmet from 'react-helmet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight } from '@fortawesome/pro-light-svg-icons';
import { navigate } from 'gatsby';
import Header from '../../common/components/Header/Header';
import Sidebar from '../../common/components/Sidebar/Sidebar';
import { siteTitle } from '../../../data/SiteConfig';
import GlobalHorizontalMenu from '../../common/components/GlobalHorizontalMenu/GlobalHorizontalMenu';
import PopUp from '../../common/components/PopUp/PopUp';
import Audit from '../../containers/Audit/Audit';
import CommonBtn from '../../containers/LeadProfile/CommonBtn/CommonBtn';
import ShowDoc from '../CMDashboard/ShowDoc';
import CMDetailView from '../CMDashboard/CMDetailView';
import PDFDocument from '../../containers/LeadProfile/PDFDocument/PDFDocument';
import InPrincipalEditor from '../../containers/LeadProfile/InPrincipalEditor/InPrincipalEditor';
import InPrincipalView from '../../containers/LeadProfile/InPrincipalView/InPrincipalView';
import {
  setApplicantionInfo,
  getApplicantionInfo
} from '../../common/utils/applicantionInfo';
import { checkApproval } from '../../common/constants/api';
import FinalSactionContainer from '../../containers/CMDashboard/FinalSaction/FinalSanctionContainer';
import LogInDetails from '../../containers/CMDashboard/LoginDetails/LogInDetails';
import CAM from '../../containers/CMDashboard/CAM/CAM';

import Disbursement from '../../containers/CMDashboard/Disbursement/Disbursement';
const backBtn_icon = '/images/icons/backBtn_icon.svg';
import { getFiltersInfo } from '../../common/utils/FiltersInfo';

const CMDocView = props => {
  const [menuArr, setMenuArr] = useState([
    'Documents',
    'CAM',
    'In-principle Indication',
    'Generate Document'
  ]);

  useEffect(() => {
    if (localStorage.hasOwnProperty('applicantionInfo')) {
      let lead_data = JSON.parse(localStorage.getItem('applicantionInfo'));
      if (lead_data?.applicationStatus !== 'In Principle Pending') {
        setMenuArr([
          'Documents',
          'CAM',
          'In-principle Indication',
          'Generate Document',
          'Login'
        ]);
      }
    }
  }, []);

  const [showFullImage, setFullImage] = useState(false);
  const [isError, setIsError] = useState(false);
  const [file, setFile] = useState(false);
  const [show, setShow] = useState(false);
  const [type, setType] = useState('loading');
  const [text, setText] = useState('loading...');
  const [reason, setReason] = useState(
    'You cannot create in-principle indication'
  );
  const [canCreate, setCanCreate] = useState(false);
  const [isApproved, setIsApproved] = useState(false);
  const [showAuditTrail, setShowAuditTrail] = useState(false);
  const [handleAuditTrail, setHandler] = useState(false);
  const [showPDFDoc, setShowPDFDoc] = useState(false);
  const [highlightedOpt, setHighlightedOpt] = useState(0);
  const [showInPrincipalIndication, setShowInPrincipalIndication] = useState(
    false
  );
  const [showFinalSanction, setShowFinalSanction] = useState(false);
  const [showLogin, setShowLogIn] = useState(false);
  const [showdisbursement, setShowDisbursement] = useState(false);
  const [triggerStatusUpdate, setTriggerStatusUpdate] = useState(false);
  const [hardReject, setHardReject] = useState(false);
  const [showCAM, setShowCAM] = useState(false);

  const listenOnStorageChange = () => {
    if (localStorage.hasOwnProperty('applicantionInfo')) {
      let lead_data = JSON.parse(localStorage.getItem('applicantionInfo'));
      updateState(lead_data.applicationStatus);
    }
  };

  const updateState = status => {
    let defalut = [
      'Documents',
      'CAM',
      'In-principle Indication',
      'Generate Document'
    ];
    if (status == 'In Principle Accepted') {
      setMenuArr([...defalut, 'Login']);
    }
    if (status == 'Login') {
      setMenuArr([...defalut, 'Login', 'Final Sanction']);
    }
    if (status == 'Sanctioned' || status == 'Disbursed') {
      setMenuArr([...defalut, 'Login', 'Final Sanction', 'Disbursement']);
    }
  };

  useEffect(() => {
    window.addEventListener('storage', listenOnStorageChange);
    listenOnStorageChange();
    return () => window.removeEventListener('storage', listenOnStorageChange);
  }, []);

  useEffect(() => {
    if (triggerStatusUpdate) updateState(triggerStatusUpdate);
  }, [triggerStatusUpdate]);

  useEffect(() => {
    let leadId = props.leadId;
    setApplicantionInfo({ ...getApplicantionInfo(), leadId: leadId });
  }, []);

  const MenuOnclickHandler = (i = 0) => {
    if (i == 0) {
      setShowPDFDoc(false);
      setShowInPrincipalIndication(false);
      setShowFinalSanction(false);
      setShowLogIn(false);
      setShowDisbursement(false);
      setShowCAM(false);
    }

    if (i == 1) {
      setShowCAM(true);
      setShowPDFDoc(false);
      setShowInPrincipalIndication(false);
      setShowFinalSanction(false);
      setShowLogIn(false);
      setShowDisbursement(false);
    }
    if (i == 2) {
      setShowPDFDoc(false);
      setShowInPrincipalIndication(true);
      setShow(true);
      setCanCreate(false);
      setShowFinalSanction(false);
      setShowLogIn(false);
      setShowDisbursement(false);
      setShowCAM(false);

      setText('Checking application status...');
      checkApproval(props.leadId).then(res => {
        setShow(false);
        setText('Loading...');
        res.canCreate ? setCanCreate(true) : null;
        res.isApproved ? setIsApproved(true) : null;
        res.comment != null ? setReason(res.comment) : null;
      });
    }
    if (i == 3) {
      setShowPDFDoc(true);
      setShowInPrincipalIndication(false);
      setShowFinalSanction(false);
      setShowLogIn(false);
      setShowDisbursement(false);
      setShowCAM(false);
    }

    if (i == 4) {
      setShowLogIn(true);
      setShowPDFDoc(false);
      setShowInPrincipalIndication(false);
      setShowFinalSanction(false);
      setShowDisbursement(false);
      setShowCAM(false);
    }
    if (i == 5) {
      setShowFinalSanction(true);
      setShowPDFDoc(false);
      setShowInPrincipalIndication(false);
      setShowLogIn(false);
      setShowDisbursement(false);
      setShowCAM(false);
    }
    if (i == 6) {
      setShowDisbursement(true);
      setShowFinalSanction(false);
      setShowPDFDoc(false);
      setShowInPrincipalIndication(false);
      setShowLogIn(false);
      setShowCAM(false);
    }
  };
  useEffect(() => {
    if (!showAuditTrail)
      setTimeout(function() {
        setHandler(false);
      }, 1000);
  }, [showAuditTrail]);
  const dashboardRedirect = () => {
    navigate('/app/dashboard');
  };
  return (
    <React.Fragment>
      <Helmet title={`Dashboard RM | ${siteTitle}`} />
      <div className="bg-grey-950 relative h-full overflow-auto font-roboto text-sm font-normal m-0 p-0 ">
        <div className=" min-h-screen flex pt-17 md:pt-0 ">
          <Sidebar />
          {handleAuditTrail ? (
            <Audit
              setShowAuditTrail={setShowAuditTrail}
              showAuditTrail={showAuditTrail}
            />
          ) : null}

          <div className="widhtMd max-screen flex-1  w-full ">
            <div className="text-black-400 text-md ml-4 font-bold absolute mt-4">
              <span className="mr-1 cursor-pointer" onClick={dashboardRedirect}>
                Dashboard
              </span>
              <FontAwesomeIcon icon={faAngleDoubleRight} className="mr-1" />
              <span className="mr-1">Documents </span>
              <FontAwesomeIcon icon={faAngleDoubleRight} className="mr-1" />
              <span className="text-green-800">
                Lead ID - {getApplicantionInfo().leadId}
              </span>
            </div>
            <Header />
            <div
              className="ml-4 mt-4 md:mt-0 cursor-pointer mb-5"
              onClick={() => {
                if (getFiltersInfo()?.user == 'rm') {
                  return navigate('/app/dashboard?type=cm');
                }
                navigate('/app/dashboard');
              }}
            >
              <img src={backBtn_icon} alt="" />
            </div>

            {!showFullImage ? (
              <React.Fragment>
                <div className="w-full flex items-center">
                  <div className="mt-6 text-sm float-left ml-4 flex">
                    <p>Status:</p>
                    <p className="text-sm pl-1 pr-3 font-medium">
                      {getApplicantionInfo().applicationStatus}
                    </p>
                  </div>
                  <div
                    className="mt-6 float-right ml-auto flex"
                    style={{ width: 'fit-content' }}
                  >
                    <CommonBtn
                      value="Audit Trail"
                      onClick={() => {
                        setHandler(true), setShowAuditTrail(true);
                      }}
                    />
                    <div className="mr-5">
                      <CommonBtn
                        value="Reject Application"
                        stylesBtn={{
                          backgroundColor: 'transparent',
                          color: '#FD4F60',
                          width: 'auto',
                          marginLeft: '5px',
                          marginRight: '5px',
                          padding: '4px 10px',
                          textAlign: 'center',
                          borderRadius: '5px',
                          display: 'block',
                          border: '1px solid #FD4F60'
                        }}
                        onClick={() => {
                          setHardReject(true);
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* filter for In-Principle */}
                <div className="py-2 px-4">
                  <GlobalHorizontalMenu
                    setHighlightedOpt={setHighlightedOpt}
                    highlightedOpt={highlightedOpt}
                    onClick={MenuOnclickHandler}
                    menuArr={[...menuArr]}
                  />
                </div>
                {/* to show CAM */}
                {!showPDFDoc &&
                  !showInPrincipalIndication &&
                  !showFinalSanction &&
                  !showLogin &&
                  !showdisbursement &&
                  showCAM && <CAM />}

                {/* for Generate Document */}
                {showPDFDoc &&
                  !showInPrincipalIndication &&
                  !showFinalSanction &&
                  !showLogin &&
                  !showCAM &&
                  !showdisbursement && (
                    <PDFDocument
                      setShowPDFDoc={setShowPDFDoc}
                      showPDFDoc={showPDFDoc}
                    />
                  )}
                {/* For InPrincipal Indication */}
                {showInPrincipalIndication &&
                !showPDFDoc &&
                !showFinalSanction &&
                !showLogin &&
                !showCAM &&
                !showdisbursement ? (
                  canCreate ? (
                    <InPrincipalEditor
                      setTriggerStatusUpdate={setTriggerStatusUpdate}
                    />
                  ) : isApproved ? (
                    <InPrincipalView />
                  ) : (
                    <div className="bg-white border border-navy-400 mt-10 relative m-auto text-black-400 font-normal py-10 ml-6 mr-6 text-center">
                      {reason}
                    </div>
                  )
                ) : null}
                {showLogin ? (
                  <LogInDetails
                    setTriggerStatusUpdate={setTriggerStatusUpdate}
                  />
                ) : null}
                {showFinalSanction ? (
                  <FinalSactionContainer
                    setTriggerStatusUpdate={setTriggerStatusUpdate}
                    setHighlightedOpt={setHighlightedOpt}
                    MenuOnclickHandler={MenuOnclickHandler}
                  />
                ) : null}
                {showdisbursement ? (
                  <Disbursement
                    setTriggerStatusUpdate={setTriggerStatusUpdate}
                  />
                ) : null}

                {!showInPrincipalIndication &&
                  !showPDFDoc &&
                  !showFinalSanction &&
                  !showLogin &&
                  !showCAM &&
                  !showdisbursement && (
                    <CMDetailView
                      setHighlightedOpt={setHighlightedOpt}
                      MenuOnclickHandler={MenuOnclickHandler}
                      setFullImage={setFullImage}
                      setIsError={setIsError}
                      setFile={setFile}
                      hardReject={hardReject}
                      setHardReject={setHardReject}
                    />
                  )}
              </React.Fragment>
            ) : (
              <ShowDoc
                file={file}
                isError={isError}
                setFullImage={setFullImage}
              />
            )}
          </div>
        </div>
        <PopUp
          type={type}
          text={text}
          setShow={setShow}
          show={show}
          dontClose
        />
      </div>
    </React.Fragment>
  );
};

export default memo(CMDocView);
